
import React, { useEffect, useState } from 'react';
import useGet from '../../Hooks/useGet';
import API_ENDPOINTS from '../../Config/api';
import ProfileAvatar from '../Icons/ProfileAvatar';



export default function ProfiloModal({ isOpen, onClose }) {
  const { fetchedData: aziendaDettagli, refetch } = useGet(API_ENDPOINTS.aziendaDettagli);
  const [form, setForm] = useState({
    nome_azienda: '', partita_iva: '', codice_fiscale: '', email: '', pec: '', url: '', indirizzo: '', cap: '', citta: '', comune: '', provincia: '', stato: '', telefono: '', numero_dipendenti: '', fatturato_annuo: '', id_settore: '', codice_ateco: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 500);
    }
  }, [success, onClose]);

  useEffect(() => {
    if (aziendaDettagli) {
      setForm({
        nome_azienda: aziendaDettagli.nome_azienda || '',
        partita_iva: aziendaDettagli.partita_iva || '',
        codice_fiscale: aziendaDettagli.codice_fiscale || '',
        email: aziendaDettagli.email || '',
        pec: aziendaDettagli.pec || '',
        url: aziendaDettagli.url || '',
        indirizzo: aziendaDettagli.indirizzo || '',
        cap: aziendaDettagli.cap || '',
        citta: aziendaDettagli.citta || '',
        comune: aziendaDettagli.comune || '',
        provincia: aziendaDettagli.provincia || '',
        stato: aziendaDettagli.stato || '',
        telefono: aziendaDettagli.telefono || '',
        numero_dipendenti: aziendaDettagli.numero_dipendenti || '',
        fatturato_annuo: aziendaDettagli.fatturato_annuo || '',
        id_settore: aziendaDettagli.id_settore || '',
        codice_ateco: aziendaDettagli.codice_ateco || ''
      });
    }
  }, [aziendaDettagli]);

  // Reset form to original data when modal opens (discard unsaved edits)
  useEffect(() => {
    if (isOpen && aziendaDettagli) {
      setForm({
        nome_azienda: aziendaDettagli.nome_azienda || '',
        partita_iva: aziendaDettagli.partita_iva || '',
        codice_fiscale: aziendaDettagli.codice_fiscale || '',
        email: aziendaDettagli.email || '',
        pec: aziendaDettagli.pec || '',
        url: aziendaDettagli.url || '',
        indirizzo: aziendaDettagli.indirizzo || '',
        cap: aziendaDettagli.cap || '',
        citta: aziendaDettagli.citta || '',
        comune: aziendaDettagli.comune || '',
        provincia: aziendaDettagli.provincia || '',
        stato: aziendaDettagli.stato || '',
        telefono: aziendaDettagli.telefono || '',
        numero_dipendenti: aziendaDettagli.numero_dipendenti || '',
        fatturato_annuo: aziendaDettagli.fatturato_annuo || '',
        id_settore: aziendaDettagli.id_settore || '',
        codice_ateco: aziendaDettagli.codice_ateco || ''
      });
      setError('');
      setSuccess(false);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      const response = await fetch(API_ENDPOINTS.aziendaDettagli, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        },
        body: JSON.stringify(form)
      });
      if (![200, 202, 204].includes(response.status)) {
        let errorText = '';
        try { errorText = await response.text(); } catch (e) { errorText = '(no details)'; }
        throw new Error('Errore salvataggio: ' + response.status + ' ' + errorText);
      }
      refetch();
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Errore nel salvataggio.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Overlay solo visivo, NON blocca eventi */}
        {/* Overlay rimosso */}
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-lg p-8 w-full max-w-3xl shadow-lg relative z-10">
          <div className="flex flex-col items-center justify-center mb-2">
            <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100 mb-2">
              <ProfileAvatar className="w-20 h-20" />
            </span>
          </div>
          <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl">&times;</button>
          <h2 className="text-2xl font-bold mb-6 text-black text-center">Profilo Azienda</h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-4">
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome Azienda</label>
                <input type="text" name="nome_azienda" value={form.nome_azienda} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required minLength="2" maxLength="255" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Partita IVA</label>
                <input type="text" name="partita_iva" value={form.partita_iva} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[0-9]{11}" minLength="11" maxLength="11" title="Inserire una Partita IVA valida (11 cifre)" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Codice Fiscale</label>
                <input type="text" name="codice_fiscale" value={form.codice_fiscale} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" style={{ textTransform: 'uppercase' }} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" title="Inserire un indirizzo email valido" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">PEC</label>
                <input type="email" name="pec" value={form.pec} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" title="Inserire un indirizzo PEC valido" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Dominio Aziendale</label>
                <input type="text" name="url" value={form.url} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" title="Inserire il dominio aziendale" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Indirizzo</label>
                <input type="text" name="indirizzo" value={form.indirizzo} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">CAP</label>
                <input type="text" name="cap" value={form.cap} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" pattern="[0-9]{5}" minLength="5" maxLength="5" title="Inserire un CAP valido (5 cifre)" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Città</label>
                <input type="text" name="citta" value={form.citta} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Comune</label>
                <input type="text" name="comune" value={form.comune} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Provincia</label>
                <input type="text" name="provincia" value={form.provincia} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Stato</label>
                <input type="text" name="stato" value={form.stato} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Telefono</label>
                <input type="text" name="telefono" value={form.telefono} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Numero Dipendenti</label>
                <input type="number" name="numero_dipendenti" value={form.numero_dipendenti} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" min="0" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fatturato Annuo (€)</label>
                <input type="number" name="fatturato_annuo" value={form.fatturato_annuo} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" min="0" step="0.01" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Settore</label>
                <input type="text" value={aziendaDettagli?.nome_settore || ''} readOnly className="w-full p-2 border rounded bg-gray-100 cursor-not-allowed opacity-70" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Codice ATECO</label>
                <input type="text" name="codice_ateco" value={form.codice_ateco} onChange={handleChange} className="w-full p-2 border rounded disabled:opacity-60" />
              </div>
              {/* Messaggi di errore/successo */}
              <div className="col-span-2">
                {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
                {success && <div className="text-green-500 text-sm mb-2">Salvataggio effettuato!</div>}
              </div>
              {/* Bottoni */}
              <div className="col-span-3 flex justify-center space-x-3 mt-2">
                <button
                  type="button"
                  className="flex items-center gap-2 bg-yellow-500 text-white shadow-md hover:bg-yellow-600 hover:shadow-lg transition-all duration-300 px-5 py-2 rounded-md active:scale-95 disabled:opacity-50"
                  onClick={onClose}
                  disabled={loading}
                >
                  Chiudi
                </button>
                <button
                  type="submit"
                  className="flex items-center gap-2 bg-yellow-500 text-white shadow-md hover:bg-yellow-600 hover:shadow-lg transition-all duration-300 px-5 py-2 rounded-md active:scale-95 disabled:opacity-50"
                  disabled={loading}
                >
                  {loading ? 'Salvataggio...' : 'Salva'}
                </button>
              </div>
            </>
          </form>
        </div>
      </div>
    </div>
  );
}